module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align-right",
    attrs: {
      "id": "mainmenu"
    }
  }, [_c('div', {
    attrs: {
      "id": "menu-content"
    }
  }, [_c('ul', {
    staticClass: "unstyled"
  }, _vm._l((_vm.links), function(link) {
    return _c('li', {
      on: {
        "click": _vm.handleNavigation
      }
    }, [_c('router-link', {
      staticClass: "main-nav-item",
      class: _vm.linkClasses(link),
      attrs: {
        "to": {
          name: link.to
        },
        "exact": ""
      }
    }, [_vm._v(_vm._s(link.name))])], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52b98264","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationMenu.vue
// module id = 915
// module chunks = 1